var map = {
	"./default_new_en-US.png": "KJ/u",
	"./default_new_zh-CN.png": "U06M",
	"./default_new_zh-TW.png": "ctL5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NTCM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/v2/default ^\.\/default_new_.*\.png$
// module id = NTCM
// module chunks = 24